export default __webpack_public_path__ + "static/media/iphonegold.6fda72a1.png";